module.exports = __webpack_public_path__ + "img/aspect-ratio-fill.789664dd.svg";